<template>
  <aside
    class="private-feedback-panel"
  >
    <div class="background">
    </div>
    <div class="feedback-panel-content-wrp">
      <a class="collapse-button" @click="closeFeedbackPanel" v-tooltip="'Collapse'">
        <aha-icon
          name="arrow-no-tail"
          class="collapse-button-icon"
          viewBox="0 0 8 14"
          width="12"
          height="21"
        />
      </a>
      <div v-if="isOpeningPrivateFeedback">
        <aha-spinner variant="white" size="lg" />
      </div>
      <div v-else class="px-2">
        <div v-if="!openFeedbackFormRequestSent" class="flex flex-col items-center justify-center text-primary-20">
          <aha-icon
            name="audience-feedback"
            class="mb-4 ml-6"
            width="80"
            height="80"
          />

          <aha-button @click="triggerOpenFeedbackForm" variant="white" class="get-feedback-btn">
            {{ $t('Get feedback') }}
          </aha-button>
          <p class="text-center text-base-60 text-sm">
            {{ $t("Don't worry, it's private!") }}
          </p>
        </div>
        <div v-else>
          <div class="flex flex-col items-center justify-center text-primary-20">
            <aha-icon
              name="audience-feedback"
              class="mb-4 ml-6"
              width="80"
              height="80"
            />
            <h4
              v-html="$t(`Audience can now leave feedback!`)"
              class="mb-4 text-center text-lg break-words wrap font-bold"
            >
            </h4>
          </div>
          <div class="link-to-report-text text-sm text-base-60">
            <p class="text-center">
              {{ $t("View in") }}
            </p>
            <p class="text-center">
              <a class="text-link" @click="openPresentationReport">{{ $t("presentation report") }}</a>
              <aha-icon
                name="open-new-window"
                class="text-base-60"
                width="20"
                height="20"
                viewBox="-4 -4 32 32"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Config from '@/config'
import FeedbackPanelMixin from '@/mixins/presentation/FeedbackPanelMixin'

export default {
  mixins: [FeedbackPanelMixin],
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
    slideActive: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      openFeedbackFormRequestSent: false,
    }
  },
  computed: {
    ...mapGetters(['isOpeningPrivateFeedback']),
  },
  methods: {
    ...mapActions(['openAudiencePrivateFeedbackAction']),
    closeFeedbackPanel() {
      this.$emit('close')
      this.trackFeedbackPanelEvent('Private feedback > Collapse panel')
    },

    async triggerOpenFeedbackForm() {
      await this.openAudiencePrivateFeedbackAction(this.presentation)
      this.openFeedbackFormRequestSent = true
      this.trackFeedbackPanelEvent('Private feedback > Open form')
    },

    openPresentationReport() {
      this.trackFeedbackPanelEvent('Private feedback > Open report')
      window.open(`${Config.presenterDomain}/apps/report/${this.presentation.id}?tab=feedback`, '_blank')
    },
  },
}

</script>
<style lang="scss" scoped>
// the following CSS rules override the flex.scss stupid rules at the moment

.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}

.mb-4 {
  margin-bottom: 16px;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.text-center {
  text-align: center;
}

.text-lg {
  font-size: 1.5rem;
}
.background {
  @apply bg-secondary-60;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.private-feedback-panel {
  height: 80%;
  width: 20%;
  position: absolute;
  background: #fff;
  top: 10%;
  right: 0;
  z-index: 149;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.collapse-button {
  @apply cursor-pointer float-right text-secondary-20 flex items-center justify-center w-8 h-12;
  @apply bg-secondary-60;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-80%, -50%);
  font-size: 0.8em;

  & .collapse-button-icon {
    @apply text-secondary-20;
  }
}

.feedback-panel-content-wrp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 151;
  & .get-feedback-btn {
    margin-bottom: 16px;
    padding: 6px 24px;
  }

  .content, .content2 {
    @apply text-primary-20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.private-feedback {
  padding: 16px;
  margin-bottom: 32px;
}
.link-to-report-text {
  text-align: center;
  position: absolute;
  bottom: 16px;
  width: calc(100% - 1rem);
  left: 50%;
  transform: translateX(-50%);

  .text-link {
    text-decoration: underline !important;
  }
}

</style>
